import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "../../design-system/primitives/Icon";
import { getPageContext } from "./pageContext";
import styles from "./PageContextBar.module.css";

export function PageContextBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const context = getPageContext(location.pathname);
  if (!context) return null;

  return <div className={styles.bar}>
    <nav className={styles.breadcrumbs} aria-label="Sayfa yolu">
      <Link to="/" aria-label="Ana Sayfa"><Icon name="home" /></Link>
      {context.breadcrumbs.map((crumb, index) => <span key={`${crumb.path}-${index}`}>
        <b aria-hidden="true">›</b>
        {index === context.breadcrumbs.length - 1 ? <span aria-current="page">{crumb.label}</span> : <Link to={crumb.path}>{crumb.label}</Link>}
      </span>)}
    </nav>
    <nav className={styles.historyActions} aria-label="Gezinme geçmişi">
      <button className={styles.back} type="button" aria-label="Önce açılan sayfaya dön" title="Geri" onClick={() => navigate(-1)}>←</button>
      <button className={styles.forward} type="button" aria-label="İleri sayfaya git" title="İleri" onClick={() => navigate(1)}>→</button>
    </nav>
  </div>;
}
